import React from "react";
import "./styles.scss";
import moment from "moment";
import { Popconfirm } from "antd";

const JobCategoryCard = (props) => {
  const onClickCancel = (e) => {
    console.log(e);
  };

  return (
    <>
      <div
        className={`hne-job-category-wrapper ${props.isSelect ? "active" : ""}`}
      >
        <div className="jcw-logo">
          {/* <img src={props.logo} alt="logo" /> */}
        </div>
        <div className="jcw-details-wrapper">
          <div className="jcw-id">{props.id}</div>
          <div className="jcw-name">{props.name}</div>
        </div>

        <div className="jcw-buttons-wrapper" onClick={props.onClickEdit}>
          <div className="jcw-edit">{props.edit}</div>
        </div>
        <div className="jcw-buttons-wrapper">
          <div className="jcw-delete">
            <Popconfirm
              placement="topLeft"
              title="Delete the image"
              description="Are you sure to delete this Image?"
              onConfirm={props.onClickRemove}
              onCancel={onClickCancel}
              okText="Yes"
              cancelText="No"
            >
              {props.delete}
              {/* <span className="remove-button"> {GetIconByName("cross")}</span>{" "} */}
            </Popconfirm>
          </div>
        </div>
      </div>
    </>
  );
};
export default JobCategoryCard;
